// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.menu-bar_menu-bar_mHbUn {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 0.5rem;

    /*
        For most things, we shouldn't explicitly set height, and let the
        content push the element to whatever fits. Using a fixed height
        instead, will help us subtract the value we assign from the body,
        adding up to a perfect 100%. This means we don't need to set
        overflow: hidden, which makes it hard to debug. border-box
        simplifies by all of this by removing padding from the equation.
    */
    box-sizing: border-box;
    height: 3rem;

    /*
        @todo: This adds ~20px in Chrome, when scrolling to the right,
        but fixes [FFx + Safari] [resize window down + scroll to the right] bug.
        width: 100%;
    */
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.75rem;
    font-weight: bold;
    background-color: var(--menu-bar-background);
    background-image: var(--menu-bar-background-image);
    color: var(--menu-bar-foreground);
}

.menu-bar_menu-bar_mHbUn.menu-bar_centered_BmK6s {
    justify-content: space-between;
}

.menu-bar_menu-bar_mHbUn.menu-bar_centered_BmK6s > .menu-bar_settings-menu_evjrV,
.menu-bar_menu-bar_mHbUn.menu-bar_centered_BmK6s > .menu-bar_account-info-group_hCKZ1 {
    flex: 1;
}

.menu-bar_menu-bar_mHbUn.menu-bar_centered_BmK6s > .menu-bar_main-menu_pHO0P {
    flex: 1;
    justify-content: center;
}

.menu-bar_settings-menu_evjrV {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.5rem;
}

.menu-bar_main-menu_pHO0P {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    flex-grow: 1;
    gap: 0.5rem;
}

.menu-bar_inactive_APqeg {
    opacity: 0;
}

.menu-bar_dash-logo_Q7AJ9 {
    transition: height 0.3s ease;
    height: 2.25rem;
    color: inherit;
}

.menu-bar_dash-logo_Q7AJ9:hover {
    height: 2.40rem;
}

.menu-bar_dash-logo_Q7AJ9:clickable {
    cursor: pointer;
}

/* Styles for search panel from Scratch */

/* https://github.com/scratchfoundation/scratch-www/blob/develop/src/components/navigation/www/navigation.scss */

.menu-bar_menu-bar-search_ZfBIp {
    position: relative;
    width: 14rem;
    min-width: 14rem;
    flex: 0 0 14rem;
    height: 3rem;
    display: flex;
    align-items: center;
}

.menu-bar_menu-bar-search-input_QW1s4,
.menu-bar_menu-bar-search-button_jl85I {
    display: inline-block;
    outline: none;
    border: 0;
    background-color: var(--ui-black-transparent);
    height: 2.25rem;
    box-sizing: border-box;
}

.menu-bar_menu-bar-search-input_QW1s4 {
    transition: .15s ease background-color;
    margin: 0;
    padding: 0;
    padding-right: 0.625rem;
    padding-left: 2.5rem;
    width: calc(100% - 2.5rem);
    color: var(--menu-bar-foreground);
    font-size: .85em;
    border-radius: calc(0.5rem / 2);
    line-height: 1.2;
}

.menu-bar_menu-bar-search-input_QW1s4::-ms-input-placeholder {
    color: rgba(255, 255, 255, .75);
}

.menu-bar_menu-bar-search-input_QW1s4::placeholder {
    color: rgba(255, 255, 255, .75);
}

.menu-bar_menu-bar-search-input_QW1s4:focus {
    transition: .15s ease background-color;
    background-color: rgba(0, 0, 0, .25);
}

.menu-bar_menu-bar-search-button_jl85I {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    background-color: transparent;
    border: 0;
    width: 2.5rem;
    height: 100%;
    padding: 0;
    cursor: pointer;
}

.menu-bar_menu-bar-search-icon_IgdrQ {
    width: 0.875rem;
    height: 0.875rem;
    opacity: 0.75;
}

.menu-bar_menu-bar-search-button_jl85I:hover .menu-bar_menu-bar-search-icon_IgdrQ {
    opacity: 1;
}

.menu-bar_menu-bar-item_AoQo9 {
    display: flex;
    text-decoration: none;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    align-self: center;
    position: relative;
    align-items: center;
    white-space: nowrap;
    height: 3rem;
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_hoverable_O4JM1 {
    cursor: pointer;
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_active_CxG9A,
.menu-bar_menu-bar-item_AoQo9.menu-bar_hoverable_O4JM1:hover {
    background-color: var(--ui-black-transparent);
}

.menu-bar_menu-bar-item_AoQo9.menu-bar_growable_G1Fy8 {
    max-width: 12rem;
    flex: 1;
}

.menu-bar_title-field-growable_d4aev {
    flex-grow: 1;
    width: 2rem;
}

.menu-bar_file-group_jsHxa, .menu-bar_settings-group_HR3r7 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}

.menu-bar_file-group_jsHxa .menu-bar_menu-bar-item_AoQo9, .menu-bar_settings-group_HR3r7 .menu-bar_menu-bar-item_AoQo9 {
    padding: 0 0.5rem;
}

.menu-bar_menu-bar-menu_cPn87 {
    margin-top: 3rem;
    z-index: 491;
}

.menu-bar_feedback-link_SD7ny {
    color: var(--menu-bar-background);
    text-decoration: none;
}

.menu-bar_feedback-button_DzR4T {
    background-color: white;
    color: inherit;
    height: 34px;
}

.menu-bar_divider_mMopV {
    height: 34px;
}

.menu-bar_author-info_rNAMH {
    margin-left: .25rem;
    margin-right: .6875rem;
}

.menu-bar_menu-bar-button_CptJx {
    height: 2rem;
}

.menu-bar_remix-button_xdVwQ {
    background-color: var(--pen-primary)
}

.menu-bar_remix-button-is-disabled_wNhP0 {
    background-color: var(--ui-black-transparent);
    cursor: default;
}

.menu-bar_remix-spinner_AnGmK {
    vertical-align: middle;
}

.menu-bar_remix-button-icon_X6kcs {
    height: 1.25rem;
}

.menu-bar_coming-soon_OILR0 > :not(.menu-bar_coming-soon-tooltip_TIPUP) {
    opacity: 0.5;
}

.menu-bar_account-info-group_hCKZ1 {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: nowrap;
    align-items: center;
    flex-grow: 1;
    gap: 0.5rem;
}

.menu-bar_account-info-group_hCKZ1 .menu-bar_menu-bar-item_AoQo9:not(:has([class*="save-status_save-now_"])) {
    padding: 0 0.75rem;
}

.menu-bar_mystuff-icon_jVWTU, .menu-bar_messages-icon_PqrAJ {
    margin: 0 .25rem;
    height: 1rem;
}

.menu-bar_help-icon_VsnHI {
    margin: 0 .25rem 0 0;
}

[dir="rtl"] .menu-bar_help-icon_VsnHI {
    margin: 0 0 0 .25rem;
}

.menu-bar_account-nav-menu_e33tH, .menu-bar_mystuff-button_rrYLw, .menu-bar_messages-button_skz6f {
    padding: 0 .25rem;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.menu-bar_messages-count_Wp8jJ {
    display: none;
}

.menu-bar_messages-count-visible_f97pV {
    display: block;
    position: absolute;
    top: .5rem;
    right: .25rem;
    border-radius: 1rem;
    background-color: var(--data-primary);
    padding: 0 .25rem;
    text-indent: 0;
    line-height: 1rem;
    color: white;
    font-size: .7rem;
    font-weight: bold;
}

.menu-bar_profile-icon_ayYUl {
    margin: 0 .25rem;
    width: 2rem;
    border-radius: calc(0.5rem / 2);
}

.menu-bar_dropdown-caret-icon_GBcap {
    width: 0.5rem;
    height: 0.5rem;
}

[dir="ltr"] .menu-bar_dropdown-caret-icon_GBcap {
    margin-left: .5rem;
}

[dir="rtl"] .menu-bar_dropdown-caret-icon_GBcap {
    margin-right: .5rem;
}

.menu-bar_disabled_IMRqW {
    opacity: 0.5;
}

.menu-bar_mystuff_k028c > a {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 45%;
  padding-right: 10px;
  padding-left: 10px;
  width: 30px;
  overflow: hidden;
  text-indent: 50px;
  white-space: nowrap;
}

.menu-bar_mystuff_k028c > a:hover {
  background-size: 50%;
}

.menu-bar_mystuff_k028c > a {
  /* background-image: url("/images/mystuff.png"); */
}

.menu-bar_about-icon_AJM3M {
    height: 1.25rem;
    margin: 0.5rem;
    vertical-align: middle;
}

.menu-bar_collapsible-label_o1JjP {
    margin: 0 .25rem;
}

@media only screen and (max-width: 1500px) {
    .menu-bar_tutorials-label_xQoKM, .menu-bar_collapsible-label_o1JjP {
        display: none;
    }

    .menu-bar_help-icon_VsnHI {
        margin-right: 0;
    }
}

.menu-bar_menu-item-link_exwIT {
    color: inherit;
    text-decoration: none;
}

.menu-bar_editor-button_BB3gS {
    padding: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/menu-bar.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;;IAEX;;;;;;;KAOC;IACD,sBAAsB;IACtB,YAAY;;IAEZ;;;;KAIC;IACD,2DAA2D;IAC3D,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;IAC5C,kDAAkD;IAClD,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,OAAO;AACX;;AAEA;IACI,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC;;AAEzC,gHAAgH;;AAEhH;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,6CAA6C;IAC7C,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;IAC1B,iCAAiC;IACjC,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.menu-bar {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    gap: 0.5rem;\n\n    /*\n        For most things, we shouldn't explicitly set height, and let the\n        content push the element to whatever fits. Using a fixed height\n        instead, will help us subtract the value we assign from the body,\n        adding up to a perfect 100%. This means we don't need to set\n        overflow: hidden, which makes it hard to debug. border-box\n        simplifies by all of this by removing padding from the equation.\n    */\n    box-sizing: border-box;\n    height: 3rem;\n\n    /*\n        @todo: This adds ~20px in Chrome, when scrolling to the right,\n        but fixes [FFx + Safari] [resize window down + scroll to the right] bug.\n        width: 100%;\n    */\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.75rem;\n    font-weight: bold;\n    background-color: var(--menu-bar-background);\n    background-image: var(--menu-bar-background-image);\n    color: var(--menu-bar-foreground);\n}\n\n.menu-bar.centered {\n    justify-content: space-between;\n}\n\n.menu-bar.centered > .settings-menu,\n.menu-bar.centered > .account-info-group {\n    flex: 1;\n}\n\n.menu-bar.centered > .main-menu {\n    flex: 1;\n    justify-content: center;\n}\n\n.settings-menu {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.main-menu {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    align-items: center;\n    flex-grow: 1;\n    gap: 0.5rem;\n}\n\n.inactive {\n    opacity: 0;\n}\n\n.dash-logo {\n    transition: height 0.3s ease;\n    height: 2.25rem;\n    color: inherit;\n}\n\n.dash-logo:hover {\n    height: 2.40rem;\n}\n\n.dash-logo:clickable {\n    cursor: pointer;\n}\n\n/* Styles for search panel from Scratch */\n\n/* https://github.com/scratchfoundation/scratch-www/blob/develop/src/components/navigation/www/navigation.scss */\n\n.menu-bar-search {\n    position: relative;\n    width: 14rem;\n    min-width: 14rem;\n    flex: 0 0 14rem;\n    height: 3rem;\n    display: flex;\n    align-items: center;\n}\n\n.menu-bar-search-input,\n.menu-bar-search-button {\n    display: inline-block;\n    outline: none;\n    border: 0;\n    background-color: var(--ui-black-transparent);\n    height: 2.25rem;\n    box-sizing: border-box;\n}\n\n.menu-bar-search-input {\n    transition: .15s ease background-color;\n    margin: 0;\n    padding: 0;\n    padding-right: 0.625rem;\n    padding-left: 2.5rem;\n    width: calc(100% - 2.5rem);\n    color: var(--menu-bar-foreground);\n    font-size: .85em;\n    border-radius: calc(0.5rem / 2);\n    line-height: 1.2;\n}\n\n.menu-bar-search-input::-ms-input-placeholder {\n    color: rgba(255, 255, 255, .75);\n}\n\n.menu-bar-search-input::placeholder {\n    color: rgba(255, 255, 255, .75);\n}\n\n.menu-bar-search-input:focus {\n    transition: .15s ease background-color;\n    background-color: rgba(0, 0, 0, .25);\n}\n\n.menu-bar-search-button {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: none;\n    background-color: transparent;\n    border: 0;\n    width: 2.5rem;\n    height: 100%;\n    padding: 0;\n    cursor: pointer;\n}\n\n.menu-bar-search-icon {\n    width: 0.875rem;\n    height: 0.875rem;\n    opacity: 0.75;\n}\n\n.menu-bar-search-button:hover .menu-bar-search-icon {\n    opacity: 1;\n}\n\n.menu-bar-item {\n    display: flex;\n    text-decoration: none;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    align-self: center;\n    position: relative;\n    align-items: center;\n    white-space: nowrap;\n    height: 3rem;\n}\n\n.menu-bar-item.hoverable {\n    cursor: pointer;\n}\n\n.menu-bar-item.active,\n.menu-bar-item.hoverable:hover {\n    background-color: var(--ui-black-transparent);\n}\n\n.menu-bar-item.growable {\n    max-width: 12rem;\n    flex: 1;\n}\n\n.title-field-growable {\n    flex-grow: 1;\n    width: 2rem;\n}\n\n.file-group, .settings-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.file-group .menu-bar-item, .settings-group .menu-bar-item {\n    padding: 0 0.5rem;\n}\n\n.menu-bar-menu {\n    margin-top: 3rem;\n    z-index: 491;\n}\n\n.feedback-link {\n    color: var(--menu-bar-background);\n    text-decoration: none;\n}\n\n.feedback-button {\n    background-color: white;\n    color: inherit;\n    height: 34px;\n}\n\n.divider {\n    height: 34px;\n}\n\n.author-info {\n    margin-left: .25rem;\n    margin-right: .6875rem;\n}\n\n.menu-bar-button {\n    height: 2rem;\n}\n\n.remix-button {\n    background-color: var(--pen-primary)\n}\n\n.remix-button-is-disabled {\n    background-color: var(--ui-black-transparent);\n    cursor: default;\n}\n\n.remix-spinner {\n    vertical-align: middle;\n}\n\n.remix-button-icon {\n    height: 1.25rem;\n}\n\n.coming-soon > :not(.coming-soon-tooltip) {\n    opacity: 0.5;\n}\n\n.account-info-group {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n    align-items: center;\n    flex-grow: 1;\n    gap: 0.5rem;\n}\n\n.account-info-group .menu-bar-item:not(:has(:global([class*=\"save-status_save-now_\"]))) {\n    padding: 0 0.75rem;\n}\n\n.mystuff-icon, .messages-icon {\n    margin: 0 .25rem;\n    height: 1rem;\n}\n\n.help-icon {\n    margin: 0 .25rem 0 0;\n}\n\n[dir=\"rtl\"] .help-icon {\n    margin: 0 0 0 .25rem;\n}\n\n.account-nav-menu, .mystuff-button, .messages-button {\n    padding: 0 .25rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.messages-count {\n    display: none;\n}\n\n.messages-count-visible {\n    display: block;\n    position: absolute;\n    top: .5rem;\n    right: .25rem;\n    border-radius: 1rem;\n    background-color: var(--data-primary);\n    padding: 0 .25rem;\n    text-indent: 0;\n    line-height: 1rem;\n    color: white;\n    font-size: .7rem;\n    font-weight: bold;\n}\n\n.profile-icon {\n    margin: 0 .25rem;\n    width: 2rem;\n    border-radius: calc(0.5rem / 2);\n}\n\n.dropdown-caret-icon {\n    width: 0.5rem;\n    height: 0.5rem;\n}\n\n[dir=\"ltr\"] .dropdown-caret-icon {\n    margin-left: .5rem;\n}\n\n[dir=\"rtl\"] .dropdown-caret-icon {\n    margin-right: .5rem;\n}\n\n.disabled {\n    opacity: 0.5;\n}\n\n.mystuff > a {\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 45%;\n  padding-right: 10px;\n  padding-left: 10px;\n  width: 30px;\n  overflow: hidden;\n  text-indent: 50px;\n  white-space: nowrap;\n}\n\n.mystuff > a:hover {\n  background-size: 50%;\n}\n\n.mystuff > a {\n  /* background-image: url(\"/images/mystuff.png\"); */\n}\n\n.about-icon {\n    height: 1.25rem;\n    margin: 0.5rem;\n    vertical-align: middle;\n}\n\n.collapsible-label {\n    margin: 0 .25rem;\n}\n\n@media only screen and (max-width: 1500px) {\n    .tutorials-label, .collapsible-label {\n        display: none;\n    }\n\n    .help-icon {\n        margin-right: 0;\n    }\n}\n\n.menu-item-link {\n    color: inherit;\n    text-decoration: none;\n}\n\n.editor-button {\n    padding: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `menu-bar_menu-bar_mHbUn`;
export { _1 as "menu-bar" };
export var menuBar = `menu-bar_menu-bar_mHbUn`;
export var centered = `menu-bar_centered_BmK6s`;
var _2 = `menu-bar_settings-menu_evjrV`;
export { _2 as "settings-menu" };
export var settingsMenu = `menu-bar_settings-menu_evjrV`;
var _3 = `menu-bar_account-info-group_hCKZ1`;
export { _3 as "account-info-group" };
export var accountInfoGroup = `menu-bar_account-info-group_hCKZ1`;
var _4 = `menu-bar_main-menu_pHO0P`;
export { _4 as "main-menu" };
export var mainMenu = `menu-bar_main-menu_pHO0P`;
export var inactive = `menu-bar_inactive_APqeg`;
var _5 = `menu-bar_dash-logo_Q7AJ9`;
export { _5 as "dash-logo" };
export var dashLogo = `menu-bar_dash-logo_Q7AJ9`;
var _6 = `menu-bar_menu-bar-search_ZfBIp`;
export { _6 as "menu-bar-search" };
export var menuBarSearch = `menu-bar_menu-bar-search_ZfBIp`;
var _7 = `menu-bar_menu-bar-search-input_QW1s4`;
export { _7 as "menu-bar-search-input" };
export var menuBarSearchInput = `menu-bar_menu-bar-search-input_QW1s4`;
var _8 = `menu-bar_menu-bar-search-button_jl85I`;
export { _8 as "menu-bar-search-button" };
export var menuBarSearchButton = `menu-bar_menu-bar-search-button_jl85I`;
var _9 = `menu-bar_menu-bar-search-icon_IgdrQ`;
export { _9 as "menu-bar-search-icon" };
export var menuBarSearchIcon = `menu-bar_menu-bar-search-icon_IgdrQ`;
var _a = `menu-bar_menu-bar-item_AoQo9`;
export { _a as "menu-bar-item" };
export var menuBarItem = `menu-bar_menu-bar-item_AoQo9`;
export var hoverable = `menu-bar_hoverable_O4JM1`;
export var active = `menu-bar_active_CxG9A`;
export var growable = `menu-bar_growable_G1Fy8`;
var _b = `menu-bar_title-field-growable_d4aev`;
export { _b as "title-field-growable" };
export var titleFieldGrowable = `menu-bar_title-field-growable_d4aev`;
var _c = `menu-bar_file-group_jsHxa`;
export { _c as "file-group" };
export var fileGroup = `menu-bar_file-group_jsHxa`;
var _d = `menu-bar_settings-group_HR3r7`;
export { _d as "settings-group" };
export var settingsGroup = `menu-bar_settings-group_HR3r7`;
var _e = `menu-bar_menu-bar-menu_cPn87`;
export { _e as "menu-bar-menu" };
export var menuBarMenu = `menu-bar_menu-bar-menu_cPn87`;
var _f = `menu-bar_feedback-link_SD7ny`;
export { _f as "feedback-link" };
export var feedbackLink = `menu-bar_feedback-link_SD7ny`;
var _10 = `menu-bar_feedback-button_DzR4T`;
export { _10 as "feedback-button" };
export var feedbackButton = `menu-bar_feedback-button_DzR4T`;
export var divider = `menu-bar_divider_mMopV`;
var _11 = `menu-bar_author-info_rNAMH`;
export { _11 as "author-info" };
export var authorInfo = `menu-bar_author-info_rNAMH`;
var _12 = `menu-bar_menu-bar-button_CptJx`;
export { _12 as "menu-bar-button" };
export var menuBarButton = `menu-bar_menu-bar-button_CptJx`;
var _13 = `menu-bar_remix-button_xdVwQ`;
export { _13 as "remix-button" };
export var remixButton = `menu-bar_remix-button_xdVwQ`;
var _14 = `menu-bar_remix-button-is-disabled_wNhP0`;
export { _14 as "remix-button-is-disabled" };
export var remixButtonIsDisabled = `menu-bar_remix-button-is-disabled_wNhP0`;
var _15 = `menu-bar_remix-spinner_AnGmK`;
export { _15 as "remix-spinner" };
export var remixSpinner = `menu-bar_remix-spinner_AnGmK`;
var _16 = `menu-bar_remix-button-icon_X6kcs`;
export { _16 as "remix-button-icon" };
export var remixButtonIcon = `menu-bar_remix-button-icon_X6kcs`;
var _17 = `menu-bar_coming-soon_OILR0`;
export { _17 as "coming-soon" };
export var comingSoon = `menu-bar_coming-soon_OILR0`;
var _18 = `menu-bar_coming-soon-tooltip_TIPUP`;
export { _18 as "coming-soon-tooltip" };
export var comingSoonTooltip = `menu-bar_coming-soon-tooltip_TIPUP`;
var _19 = `menu-bar_mystuff-icon_jVWTU`;
export { _19 as "mystuff-icon" };
export var mystuffIcon = `menu-bar_mystuff-icon_jVWTU`;
var _1a = `menu-bar_messages-icon_PqrAJ`;
export { _1a as "messages-icon" };
export var messagesIcon = `menu-bar_messages-icon_PqrAJ`;
var _1b = `menu-bar_help-icon_VsnHI`;
export { _1b as "help-icon" };
export var helpIcon = `menu-bar_help-icon_VsnHI`;
var _1c = `menu-bar_account-nav-menu_e33tH`;
export { _1c as "account-nav-menu" };
export var accountNavMenu = `menu-bar_account-nav-menu_e33tH`;
var _1d = `menu-bar_mystuff-button_rrYLw`;
export { _1d as "mystuff-button" };
export var mystuffButton = `menu-bar_mystuff-button_rrYLw`;
var _1e = `menu-bar_messages-button_skz6f`;
export { _1e as "messages-button" };
export var messagesButton = `menu-bar_messages-button_skz6f`;
var _1f = `menu-bar_messages-count_Wp8jJ`;
export { _1f as "messages-count" };
export var messagesCount = `menu-bar_messages-count_Wp8jJ`;
var _20 = `menu-bar_messages-count-visible_f97pV`;
export { _20 as "messages-count-visible" };
export var messagesCountVisible = `menu-bar_messages-count-visible_f97pV`;
var _21 = `menu-bar_profile-icon_ayYUl`;
export { _21 as "profile-icon" };
export var profileIcon = `menu-bar_profile-icon_ayYUl`;
var _22 = `menu-bar_dropdown-caret-icon_GBcap`;
export { _22 as "dropdown-caret-icon" };
export var dropdownCaretIcon = `menu-bar_dropdown-caret-icon_GBcap`;
export var disabled = `menu-bar_disabled_IMRqW`;
export var mystuff = `menu-bar_mystuff_k028c`;
var _23 = `menu-bar_about-icon_AJM3M`;
export { _23 as "about-icon" };
export var aboutIcon = `menu-bar_about-icon_AJM3M`;
var _24 = `menu-bar_collapsible-label_o1JjP`;
export { _24 as "collapsible-label" };
export var collapsibleLabel = `menu-bar_collapsible-label_o1JjP`;
var _25 = `menu-bar_tutorials-label_xQoKM`;
export { _25 as "tutorials-label" };
export var tutorialsLabel = `menu-bar_tutorials-label_xQoKM`;
var _26 = `menu-bar_menu-item-link_exwIT`;
export { _26 as "menu-item-link" };
export var menuItemLink = `menu-bar_menu-item-link_exwIT`;
var _27 = `menu-bar_editor-button_BB3gS`;
export { _27 as "editor-button" };
export var editorButton = `menu-bar_editor-button_BB3gS`;
export default ___CSS_LOADER_EXPORT___;
